var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.001,4L24.001,4A2.667,2.667 0,0 1,26.667 6.667L26.667,28A2.667,2.667 0,0 1,24.001 30.667L8.001,30.667A2.667,2.667 0,0 1,5.334 28L5.334,6.667A2.667,2.667 0,0 1,8.001 4z",
    fill: "#55A7F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667,4C11.667,3.079 12.413,2.333 13.334,2.333H18.667C19.587,2.333 20.334,3.079 20.334,4V7H11.667V4Z",
    strokeWidth: 2,
    fill: "#ffffff",
    stroke: "#55A7F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001,18.667H18.668",
    strokeWidth: 2.66667,
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001,13.333H20.001",
    strokeWidth: 2.66667,
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001,24H14.668",
    strokeWidth: 2.66667,
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.97cbfb5ea754075eb03ed2b1cd497810.svg";
export { ForwardRef as ReactComponent };